// extracted by mini-css-extract-plugin
export default {"loading":"aYjn_Ift","container":"abNhazAE","container__is_fullscreen":"ayfDF76M"};